import { useSnackbar } from '@/modules/core';
import { SnackbarState } from '@/modules/core/core.types';

const useShowAppliedSettingsSnackbar = () => {
  const { handleAddSnackbar } = useSnackbar();
  return () => {
    handleAddSnackbar({
      state: SnackbarState.positive,
      closeIcon: true,
      text: 'Settings applied',
    });
  };
};

export default useShowAppliedSettingsSnackbar;
